import React from "react";

const cloche = ({ nombre }) => (
    <svg
   xmlns="http://www.w3.org/2000/svg"
   viewBox="0 0 36 36"
   height="36"
   width="36">
  <g
     id="g4"
     style={{filter: "url(#filter0_d)"}}>
    <rect
       x="1"
       y="4.8083501"
       width="29.693899"
       height="30.5455"
       rx="4"
       id="rect2"
       style={{ fill: "#ffffff"}} />
  </g>
  <path
     d="M 22.8488,24.3714 21.9862,23.484 c -0.0779,-0.0794 -0.0675,-0.4467 -0.0675,-0.5597 v -3.8182 c 0,-2.5849 -1.7193,-4.8529 -4.0889,-5.6654 v -0.071 c 0,-1.0279 -0.8455,-1.9 -1.8499,-1.9 -1.0014,0 -1.8507,0.8721 -1.8507,1.9 v 0.071 c -2.3696,0.8125 -4.0881,3.0805 -4.0881,5.6654 v 3.8182 c 0,0.113 0.0097,0.4803 -0.06755,0.5597 l -0.86261,0.8874 c -0.26725,0.2749 -0.55528,0.785 -0.55528,1.2569 0,0.5956 0.52484,1.0806 1.16994,1.0806 h 3.2485 c 0.3051,1.3279 1.4706,2.3199 2.8573,2.3199 1.3867,0 2.812,-0.9584 3.1179,-2.2863 l 3.2849,-0.0336 c 0.6451,0 1.1691,-0.485 1.1691,-1.0806 0,-0.4704 -0.2872,-0.9813 -0.5545,-1.2569 z m -7.0176,3.3146 c -0.657,0 -1.2242,-0.4017 -1.481,-0.9775 h 2.9612 c -0.2569,0.5758 -0.824,0.9775 -1.4802,0.9775 z m 2.3755,-2.4711 c -0.1024,-0.026 0.1025,-0.026 0,0 h -4.4541 c -0.1024,-0.026 0.1025,-0.026 0,0 h -3.7117 c 0.0327,-0.1314 -0.0141,0.0137 0,0 l 0.8589,-0.7835 c 0.3214,-0.3299 0.6258,-1.0401 0.6258,-1.5075 v -3.8181 c 0,-2.1749 1.3281,-3.9954 3.4103,-4.5078 0.294,-0.0725 0.5011,-0.3421 0.5011,-0.6529 v -0.5758 c 0,-0.2795 0.2702,-0.3726 0.5427,-0.3726 0.2798,0 0.5411,0.0878 0.5411,0.3726 v 0.5758 c 0,0.3108 0.2079,0.5804 0.5019,0.6529 2.0823,0.5124 3.4111,2.3329 3.4111,4.5078 v 3.8181 c 0,0.4674 0.3043,1.1776 0.6258,1.5082 l 0.8618,0.8858 c 0.0141,0.0146 -0.0163,-0.1206 -0.0029,-0.103 z"
     id="path6"
     style={{ clipRule: "evenodd", fill: "#007adf", fillRule: "evenodd"}} />
  <path
     style={{clipRule: "evenodd", fill: "#ffffff", fillRule: "evenodd", filter: "url(#filter1_d)"}}
     id="path8"
     d="M 28.5238,14.2458 C 32.1005,14.2458 35,11.2632 35,7.58392 35,3.90464 32.1005,0.921997 28.5238,0.921997 c -3.5767,0 -6.4762,2.982643 -6.4762,6.661923 0,3.67928 2.8995,6.66188 6.4762,6.66188 z" />
  <defs
     id="defs47">
    <filter
       color-interpolation-filters="sRGB"
       filterUnits="userSpaceOnUse"
       height="64.5455"
       width="63.6939"
       y="-10.1917"
       x="-15"
       id="filter0_d">
      <feFlood
         id="feFlood14"
         result="BackgroundImageFix"
         flood-opacity="0" />
      <feColorMatrix
         id="feColorMatrix16"
         values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
         type="matrix"
         in="SourceAlpha" />
      <feOffset
         id="feOffset18"
         dy="2"
         dx="1" />
      <feGaussianBlur
         id="feGaussianBlur20"
         stdDeviation="8.5" />
      <feColorMatrix
         id="feColorMatrix22"
         values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
         type="matrix" />
      <feBlend
         id="feBlend24"
         result="effect1_dropShadow"
         in2="BackgroundImageFix"
         mode="normal" />
      <feBlend
         id="feBlend26"
         result="shape"
         in2="effect1_dropShadow"
         in="SourceGraphic"
         mode="normal" />
    </filter>
    <filter
       color-interpolation-filters="sRGB"
       filterUnits="userSpaceOnUse"
       height="21.3238"
       width="20.9524"
       y="0.921997"
       x="18.0476"
       id="filter1_d">
      <feFlood
         id="feFlood29"
         result="BackgroundImageFix"
         floodOpacity="0" />
      <feColorMatrix
         id="feColorMatrix31"
         values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
         type="matrix"
         in="SourceAlpha" />
      <feOffset
         id="feOffset33"
         dy="4" />
      <feGaussianBlur
         id="feGaussianBlur35"
         stdDeviation="2" />
      <feColorMatrix
         id="feColorMatrix37"
         values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
         type="matrix" />
      <feBlend
         id="feBlend39"
         result="effect1_dropShadow"
         in2="BackgroundImageFix"
         mode="normal" />
      <feBlend
         id="feBlend41"
         result="shape"
         in2="effect1_dropShadow"
         in="SourceGraphic"
         mode="normal" />
    </filter>
    <clipPath
       id="clip0">
      <rect
         id="rect44"
         fill="white"
         height="36"
         width="36" />
    </clipPath>
  </defs>
  <text
     id="text862"
     y="11.745763"
     x="29.291792"
     style={{fontSstyle: "normal", fontWeight: "normal", "fontSize": "12px" ,lineHeight: "125%", fontFamily: "sans-serif", textAlign: "center", letterSpacing: "0px", "wordSpacing": "0px", textAnchor: "middle", fill: "#007adf", fillOpacity: 1, stroke: "none", strokeWidth: "1px", strokeLinecap: "butt", strokeLinejoin: "miter", strokeOpacity: 1}}
     ><tspan
       y="11.745763"
       x="29.291792"
       id="tspan860">{nombre}</tspan></text>
</svg>
);

export default cloche;


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/notifications/cloche.js